import React, { useState, useEffect } from 'react';
import { VERSION } from '../config/version';
import api from '../api';
import styles from '../styles/VersionFooter.module.css';

const VersionFooter = () => {
  const [serverVersion, setServerVersion] = useState('Loading...');

  useEffect(() => {
    const fetchServerVersion = async () => {
      try {
        const response = await api.getServerVersion();
        setServerVersion(response.data.version);
      } catch (error) {
        console.error('Failed to fetch server version:', error);
        setServerVersion('Unknown');
      }
    };

    fetchServerVersion();
  }, []);

  return (
    <div className={styles.versionFooter}>
      <span>Client: {VERSION.toString()}</span>
      <span className={styles.divider}>|</span>
      <span>Server: {serverVersion}</span>
    </div>
  );
};

export default VersionFooter;
